import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CoreServiceCard from "../CoreServiceCard/CoreServiceCard";
import "./CoreServices.css";
import { Link } from "react-router-dom";

const CoreServices = () => {
    const services = [
        {
            image: "/sunglasses-card.png",
            title: "Sunglasses",
            text: "Luxury sunglasses that protect your eyes while making every outing a style statement.",
            classes: "sunglasses",
            link: "/services/sunglasses"
        },
        {
            image: "/eye-exam-card.png",
            title: "Eye Exam",
            text: "Thorough eye exams with advanced technology to keep your vision precise and healthy.",
            classes: "eye-exam",
            link: "/services/eye-exam"
        },
        {
            image: "/safety-glasses-card.png",
            title: "Safety Glasses",
            text: "Reliable and stylish protection for your eyes in any work or active environment.",
            classes: "safety-glasses",
            link: "/services/safety-glasses"
        },
        {
            image: "/eye-glasses-image.png",
            title: "Eye Glasses",
            text: "Designer eyewear that blends sophistication with perfect clarity for every look.",
            classes: "eye-glasses",
            link: "/services/eye-glasses"
        },
        {
            image: "/sports-goggles-card.png",
            title: "Sports Goggles",
            text: "High performance goggles that safeguard your eyes while supporting your active lifestyle.",
            classes: "sports-goggles",
            link: "/services/sports-goggles"
        },
        {
            image: "/contact-lenses-card.png",
            title: "Contact Lenses",
            text: "Custom fit lenses that deliver comfort, freedom and flawless vision all day.",
            classes: "contact-lenses",
            link: "/services/contact-lenses"
        }
    ];
    return (
        <section className="core-services-section text-white text-center">
            <Container>
                <Row className="g-lg-5 gap-5 py-5 gap-lg-0 py-lg-0 justify-content-center">
                    {services.map((service, index) => (
                        <Col md={12} key={index}>
                            <Link to={service.link} className="text-decoration-none">
                                <CoreServiceCard
                                    index={index}
                                    image={service.image}
                                    title={service.title}
                                    text={service.text}
                                    classes={service.classes}
                                />
                            </Link>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default CoreServices;
